import { render, staticRenderFns } from "./blanksQuestions.vue?vue&type=template&id=f32d47dc&scoped=true&"
import script from "./blanksQuestions.vue?vue&type=script&lang=js&"
export * from "./blanksQuestions.vue?vue&type=script&lang=js&"
import style0 from "./blanksQuestions.vue?vue&type=style&index=0&id=f32d47dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32d47dc",
  null
  
)

export default component.exports